<template>
  <form @submit.prevent="submitAgentForm">
    <div class="form-row">
      <div class="col-md-6 mb-4">
        <div class="input_star">
          <input type="text" class="form-control" placeholder="First Name" v-model="first_name" :class=" firstNameError ? 'is-invalid' : ''"/>
          <div class="invalid-feedback">{{ firstNameError }}</div>
        </div>
      </div>
      <div class="col-md-6 mb-4">
        <input type="text" class="form-control" placeholder="Last Name" v-model="last_name" />
      </div>
      <div class="col-xl-6 col-lg-12 mb-4">
        <div class="input_star">
          <input type="email" class="form-control" placeholder="Email" v-model="email" :class=" emailError ? 'is-invalid' : ''"/>
          <div class="invalid-feedback">{{ emailError }}</div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-12 mb-4">
        <div class="input_star">
          <input
            type="text"
            class="form-control"
            placeholder="Phone Number (10 digits only)"
            v-mask="'###-###-####'"
            v-model="mobile"
            :class="mobileError ? 'is-invalid' : ''"
          />
          <div class="invalid-feedback">{{ mobileError }}</div>
        </div>
      </div>
      <div class="col-md-12 mb-4">
        <label>
          Do you have an active real estate license in good standing and hanging with a brockerage?
          <span>*</span>
        </label>
        <div class="custom-control custom-radio custom-control-inline">
          <input
            type="radio"
            id="customRadioInline1"
            name="customRadioInline1"
            class="custom-control-input"
            :value="1"
            v-model="have_license"
          />
          <label class="custom-control-label" for="customRadioInline1">Yes</label>
        </div>
        <div class="custom-control custom-radio custom-control-inline">
          <input
            type="radio"
            id="customRadioInline2"
            name="customRadioInline1"
            class="custom-control-input"
            :value="0"
            v-model="have_license"
          />
          <label class="custom-control-label" for="customRadioInline2">No</label>
        </div>
        <div class="invalid-feedback" :class="haveLicenseError ? 'd-block' : 'd-none'">{{ haveLicenseError }}</div>
      </div>
      <div class="col-md-12 mb-4">
        <input
          type="text"
          class="form-control"
          placeholder="Your current brokerage"
          v-model="cbrokerage"
        />
      </div>
      <div class="col-md-12 mb-4">
        <div class="input_textarea">
          <span>Comments</span>
          <textarea class="form-control" v-model="comments"></textarea>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form_submit_button">
          <button type="button" @click.prevent="submitAgentForm" :disabled="processing" :style="processing ? 'opacity:0.6;cursor:not-allowed;' : ''">{{ processing ? "PROCESSING..." : "SUBMIT" }}</button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
export default {
  name: "AgentPartnerForm",
  props: {
    agent_partner: {
      default: 1
    }
  },
  data() {
    return {
      first_name: "",
      last_name: "",
      email: "",
      mobile: "",
      cbrokerage: "",
      have_license: "",
      comments: "",
      processing: false
    };
  },
  computed:{
    firstNameError(){
      if(this.$v?.first_name?.$error){
        return "Please enter first name"
      }
      return ""
    },
    emailError(){
      if (this.$v.email.$error) {
        if (!this.$v.email.required) {
          return "Email is required";
        } else if (!this.$v.email.email) {
          return "Please enter a valid email address";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    mobileError(){
      if(this.$v.mobile.$error) {
        if(!this.$v.mobile.required) {
          return 'Phone number is required';
        } else if(!this.$v.mobile.minLength || !this.$v.mobile.maxLength) {
          return 'Phone number must be a 10 digit number';
        } else {
          return "Please enter a valid phone number";
        }
      }
      return ""
    },
    haveLicenseError(){
      if(this.$v.have_license.$error) {
        return "Please select license"
      }
      return ""
    },
  },
  validations: {
    first_name: {
      required
    },
    email: {
      required,
      email
    },
    mobile: {
      required,
      minLength: minLength(12)
    },
    have_license: {
      required
    }
  },
  methods: {
    submitAgentForm() {
      this.$v.$touch();
      if(this.$v.$invalid) {
        return
      } else { 
        this.processing = true;
        const formData = new FormData();
        formData.append("first_name", this.first_name);
        formData.append("last_name", this.last_name);
        formData.append("email", this.email);
        formData.append("mobile", this.mobile);
        formData.append("user_type", this.agent_partner);
        formData.append("cbrokerage", this.cbrokerage);
        formData.append("have_license", this.have_license);
        formData.append("comments", this.comments);
  
        axios
          .post("/post-agent-partner", formData)
          .then(async res => {
            let msg = "Successfully submitted data";
            if (res?.data?.message) {
                msg = res.data.message;
            }
            this.first_name = "";
            this.last_name = "";
            this.email = "";
            this.mobile = "";
            this.cbrokerage = "";
            this.have_license = "";
            this.comments = "";
            this.$v.$reset()

            Swal.fire({
                title: msg,
                icon: "success",
                confirmButtonText: "Okay",
                timer: 3000
            });
          })
          .catch(error => {
            const restObj = {}
              if(error?.response?.data?.errors) {
                restObj.html = ''
                Object.values(error?.response?.data?.errors)?.forEach((err)=>{
                  restObj.html+=`<p style="color:red">${err[0]}</p>`
                })
              }
              if (error?.response?.data?.message) {
                    Swal.fire({
                    title: error?.response.data.message,
                    icon: "error",
                    timer: 3000,
                    ...restObj
                });
              }
          }).finally(res => {
            this.processing = false;
          });
      }
    }
  }
};
</script>